////////LIBRARY/////////
import { createGlobalStyle, css } from 'styled-components'
///////COMPONENTS///////
import theme from './theme'
/////////ASSETS/////////
import LatoRegularEOT from '../assets/fonts/Lato-Regular.eot'
import LatoRegularTTF from '../assets/fonts/Lato-Regular.ttf'
import LatoRegularWOFF from '../assets/fonts/Lato-Regular.woff'
import LatoRegularWOFF2 from '../assets/fonts/Lato-Regular.woff2'

import LatoItalicEOT from '../assets/fonts/Lato-Italic.eot'
import LatoItalicTTF from '../assets/fonts/Lato-Italic.ttf'
import LatoItalicWOFF from '../assets/fonts/Lato-Italic.woff'
import LatoItalicWOFF2 from '../assets/fonts/Lato-Italic.woff2'

import LatoBoldEOT from '../assets/fonts/Lato-Bold.eot'
import LatoBoldTTF from '../assets/fonts/Lato-Bold.ttf'
import LatoBoldWOFF from '../assets/fonts/Lato-Bold.woff'
import LatoBoldWOFF2 from '../assets/fonts/Lato-Bold.woff2'

import LatoBoldItalicEOT from '../assets/fonts/Lato-BoldItalic.eot'
import LatoBoldItalicTTF from '../assets/fonts/Lato-BoldItalic.ttf'
import LatoBoldItalicWOFF from '../assets/fonts/Lato-BoldItalic.woff'
import LatoBoldItalicWOFF2 from '../assets/fonts/Lato-BoldItalic.woff2'

import LatoBlackEOT from '../assets/fonts/Lato-Black.eot'
import LatoBlackTTF from '../assets/fonts/Lato-Black.ttf'
import LatoBlackWOFF from '../assets/fonts/Lato-Black.woff'
import LatoBlackWOFF2 from '../assets/fonts/Lato-Black.woff2'

const { colors, font, text, background } = theme

const fontFaces = css`
	@font-face {
		font-family: 'Lato';
		src: url(${LatoRegularWOFF2}) format('woff2'), url(${LatoRegularWOFF}) format('woff'), url(${LatoRegularEOT}),
			url(${LatoRegularTTF}) format('truetype');
		font-weight: normal;
		font-style: normal;
	}
	@font-face {
		font-family: 'Lato';
		src: url(${LatoItalicWOFF2}) format('woff2'), url(${LatoItalicWOFF}) format('woff'), url(${LatoItalicEOT}),
			url(${LatoItalicTTF}) format('truetype');
		font-weight: normal;
		font-style: italic;
	}
	@font-face {
		font-family: 'Lato';
		src: url(${LatoBoldWOFF2}) format('woff2'), url(${LatoBoldWOFF}) format('woff'), url(${LatoBoldEOT}), url(${LatoBoldTTF}) format('truetype');
		font-weight: bold;
		font-style: normal;
	}
	@font-face {
		font-family: 'Lato';
		src: url(${LatoBoldItalicWOFF2}) format('woff2'), url(${LatoBoldItalicWOFF}) format('woff'), url(${LatoBoldItalicEOT}),
			url(${LatoBoldItalicTTF}) format('truetype');
		font-weight: bold;
		font-style: italic;
	}
	@font-face {
		font-family: 'Lato';
		src: url(${LatoBlackWOFF2}) format('woff2'), url(${LatoBlackWOFF}) format('woff'), url(${LatoBlackEOT}),
			url(${LatoBlackTTF}) format('truetype');
		font-weight: 900;
		font-style: normal;
	}
`

const GlobalStyle = createGlobalStyle`
	${fontFaces}
    html {
		font-family: 'Lato', sans-serif;
		width: 100%;
		font-size: ${font.fm};
		color: ${text.colors.primary};
		background-color: ${colors.secondary};
        margin: auto;
        line-height: 22px;
        scrollbar-color: ${text.colors.primary};
		box-sizing: border-box;
		::-webkit-scrollbar{
			 width: 10px;
		}
		::-webkit-scrollbar-track {
    		-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
		}
		::-webkit-scrollbar-thumb {
		  background-color: ${text.colors.primary};
		  outline: 1px solid slategrey;
		  height: 30px;
		}
    }
    
	body{
		margin: auto;
		color: ${text.colors.primary};
		position: relative;
        background-color:${background.body};
        
	}
    input, select, textarea{
        font-family: 'Lato', sans-serif;
    }

	iframe#webpack-dev-server-client-overlay
{
    display: none;
}
`
export default GlobalStyle
